<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="'使い方'"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <div class="accordion-container">
        <div class="top-description">
          <p>パーツをドラッグして左の図面にドロップすることによってパーツの追加ができます。追加したパーツをダブルクリックして内容を編集してみましょう。</p>
        </div>
        <section class="accordion-wrapper disp-scroll">
          <b-collapse
            class="card"
            animation="slide"
            v-for="(collapse, index) of collapses"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button">
              <p class="card-header-title">
                {{ collapse.title }}
              </p>
              <a class="card-header-icon">
                <b-icon
                  :icon="props.open ? 'menu-down' : 'menu-up'">
                </b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="content">
                {{ collapse.text }}
              </div>
            </div>
          </b-collapse>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    const collapses = [
      {
        title: '選択肢ありメッセージ',
        text: '複数の選択肢からユーザーに選択させることができます。'
      },
      {
        title: 'メッセージのみ',
        text: 'ロボの方からメッセージを出すことができます。'
      },
      {
        title: '自由入力',
        text: 'ユーザーから入力してもらうことができます。'
      },
      {
        title: '応募フォーム',
        text: '求人や説明会などの応募情報を入力させることができます。'
      },
      {
        title: 'ロボ切替',
        text: '別のロボに切り替えることができます。'
      },
      {
        title: '日程自動調整',
        text: '面接などの日程調整を行うことができます。'
      },
      {
        title: '画像表示',
        text: '画像を表示することができます。'
      },
      {
        title: 'ファイルアップロード',
        text: 'ユーザーにファイルをアップロードさせることができます。'
      },
      {
        title: 'ファイルダウンロード',
        text: 'ユーザーにファイルをダウンロードさせることができます。'
      },
      {
        title: '履歴書フォーム',
        text: '履歴書情報を入力させたり、履歴書を提出させたりすることができます。'
      },
      {
        title: 'メール送付',
        text: 'メールを送付します。引用リストからユーザーが入力したEメールアドレスを使うことで、ユーザーへメールを送ることもできます。'
      },
      {
        title: 'SMS送付',
        text: 'SMSを送付します。引用リストからユーザーが入力した電話番号を使うことで、ユーザーへSMSを送ることもできます。'
      },
      {
        title: '条件で分ける',
        text: 'ポイントや入力内容によって分岐させることができます。'
      },
      {
        title: 'チェック項目',
        text: 'チェック項目を表示できます。'
      },
      {
        title: '動画',
        text: '動画を表示できます。'
      },
      {
        title: 'カルーセル選択',
        text: '画像と文言を同時に表示するカルーセルが表示することができます。'
      },
      {
        title: 'Startに戻る',
        text: 'シナリオの１番スタートに戻ります。'
      },
      {
        title: '付箋',
        text: 'メモができます。シナリオ上には特に影響しません。右下の赤い箇所をドラッグすると大きさを可変できます。'
      }
    ]
    return {
      collapses: collapses,
      isOpen: -1,
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .accordion-container {
    padding: 16px;
  }
  .accordion-wrapper {
    height: 480px;
    padding: 8px;
    overflow: auto;
  }
  .top-description {
    margin-bottom: 16px;
    text-align: left;
    font-size: 14px;
  }
  .card-header-title {
    font-size: 12px;
  }
  .card-content {
    .content {
      text-align: left;
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalHowToUseParts.vue